module.exports = __webpack_public_path__ + "assets/img/My-Favorites-Cover-Art.53e54c9a.png";